export const REQUEST = "/api/companies/companies/-REQUEST";
export const SUCCESS = "/api/companies/companies/-SUCCESS";
export const FAILURE = "/api/companies/companies/-FAILURE";



// WEBPACK FOOTER //
// ./src/ducks/companies/constants.js